// libs
import React, {useState} from 'react';
// components
import ConfirmationBox from '../../components/confirmation-box';
import FormModal from './form-modal';
import PrintErrorMsg from '../../components/print-error-msg';
import Button from 'react-bootstrap/Button';
// config & functions 
import config from '../../config';

function Table({loadapidata, offset, list, urlAccountId, orgInfo, token, paginationNo}) {
    const [ShowFormModalBox, setShowFormModalBox] = useState(false);
    const [ShowDeleteModalBox, setShowDeleteModalBox] = useState(false);
    const [RowId, setRowId] = useState(0);
    const deleteUrl = `${config.api.generic}/offer-code`;

    const handleDelete = (rowId) => {
        setRowId(rowId);
        setShowFormModalBox(false);
        setShowDeleteModalBox(true);
    }

    const handleUpdate = (rowId) => {
        setRowId(rowId);
        setShowDeleteModalBox(false);
        setShowFormModalBox(true);
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return 'No Expiry';
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    }

    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '50px'}}>#</th>
                            <th style={{minWidth: '120px'}}>Code</th>
                            <th style={{minWidth: '120px'}}>Discount</th>
                            <th style={{minWidth: '120px'}}>Min Order</th>
                            <th style={{minWidth: '120px'}}>Max Discount</th>
                            <th style={{minWidth: '150px'}}>Expiry Date</th>
                            <th style={{minWidth: '100px'}}>Max Usage</th>
                            <th style={{minWidth: '100px'}}>Used</th>
                            <th style={{minWidth: '100px'}}>Single Use</th>
                            <th style={{minWidth: '80px'}}>Active</th>
                            <th style={{minWidth: '180px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data, i) => {
                            const isExpired = data.expiry_date && new Date(data.expiry_date) < new Date();
                            return <tr key={Math.random()} className={isExpired ? 'table-secondary' : ''}>
                                <td>{`${pNo}.${i+1}`}</td>
                                <td><span className="fw-bold">{data.code}</span></td>
                                <td>{data.discount_type === 'percentage' ? `${data.discount_value}%` : `Rs ${data.discount_value}/-`}</td>
                                <td>Rs {data.min_order_amount}/-</td>
                                <td>{data.max_discount_amount ? `Rs ${data.max_discount_amount}/-` : '-'}</td>
                                <td>
                                    <span className={isExpired ? 'text-danger' : ''}>{formatDate(data.expiry_date)}</span>
                                </td>
                                <td>{data.max_usage_count || 'Unlimited'}</td>
                                <td>{data.usage_count}</td>
                                <td>{data.is_single_use_per_user ? 'Yes' : 'No'}</td>
                                <td>
                                    <span className={`badge ${data.is_active ? 'bg-success' : 'bg-secondary'} me-2`}>
                                        {data.is_active ? 'Active' : 'Inactive'}
                                    </span>
                                </td>
                                <td>
                                    <Button variant="secondary" onClick={() => handleUpdate(data.pk_id)} className="fs-14rem me-3 p-0 border-0 bg-transparent text-primary">Update</Button>
                                    <Button variant="secondary" onClick={() => handleDelete(data.pk_id)} className="fs-14rem me-3 p-0 border-0 bg-transparent text-danger">Delete</Button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowDeleteModalBox) ? <ConfirmationBox loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowdeletemodalbox={setShowDeleteModalBox} url={deleteUrl} params={{id: RowId}} token={token} /> : null}
            {(ShowFormModalBox) ? <FormModal loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowformmodalbox={setShowFormModalBox} orgaccountid={urlAccountId} rowid={RowId} token={token} orginfo={orgInfo} /> : null}
        </>
    } else {
        return <PrintErrorMsg msg={'No offer codes available'} />;
    }
}

export default Table;
